import { render, staticRenderFns } from "./DepositWithholdDialog.vue?vue&type=template&id=af615230"
import script from "./DepositWithholdDialog.vue?vue&type=script&lang=js"
export * from "./DepositWithholdDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports